// src/pages/Dashboard.js
import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function Dashboard() {
  const { user, permissions } = useSelector((state) => state.auth);
  console.log(user);
  console.log(permissions);
  console.log(user.role);

  // Quick link cards based on permissions
  const cards = [];
  if (permissions && permissions.includes('shipping')) {
    cards.push({ title: 'Shipping', link: '/shipping' });
  }
  if (user.role && (user.role.includes('admin') || user.role.includes('superuser'))) {
    cards.push({ title: 'User Management', link: '/users' });
  }
  if (user.role && user.role.includes('superuser')) {
    cards.push({ title: 'Logs', link: '/logs' });
  }
  if (permissions && permissions.includes('all')) {
    cards.push({ title: 'Logs', link: '/logs' });
    cards.push({ title: 'User Management', link: '/users' });
    cards.push({ title: 'Shipping', link: '/shipping' });
  }

  return (
    <Container className="mt-4">
      <h2>Welcome, {user?.name}</h2>
      <p>{user?.email}</p>
      <Row className="mt-4">
        {cards.length > 0 ? (
          cards.map((card, index) => (
            <Col key={index} sm={12} md={6} lg={4} className="mb-3">
              <Card bg="secondary" text="light">
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text>Access the {card.title} app</Card.Text>
                  <Card.Link as={Link} to={card.link}>
                    Go to {card.title}
                  </Card.Link>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <p>No apps available based on your permissions.</p>
        )}
      </Row>
    </Container>
  );
}

export default Dashboard;
